import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../customHooks/useAuth'
import { RefreshHandler } from '../utils/refresh-handler'
import Layout from '../layout/layout'

type ProtectedRouteProps = {
  children: React.JSX.Element
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user } = useAuth()
  if (!user?.authenticated) {
    return <Navigate to="/sign-in" replace />
  }

  return (
    <React.Fragment>
      <RefreshHandler />
      <Layout>{children}</Layout>
    </React.Fragment>
  )
}

export default ProtectedRoute
